import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { ILoggerDeployment } from '@app/api/interfaces/logger-deployment-data.interface';
import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';

export const loggerDeploymentsKey = 'loggerDeployments';

export const loggerDeploymentsAdapter = createEntityAdapter<ILoggerDeployment>({
  selectId: loggerDeployment => loggerDeployment.id,
  sortComparer: false,
});

export interface ILoggerDeploymentsRequestState {
  projectId: string;
  areaId?: string;
  date?: string;
  detailed?: boolean;
}

export interface ILoggerDeploymentsState extends EntityState<ILoggerDeployment> {
  loaded: boolean;
  loading: boolean;
  triggerId: string | null;
  request: ILoggerDeploymentsRequestState | null;
  error: IApiBaseErrorResponse | null;
}

export const initialState: ILoggerDeploymentsState = loggerDeploymentsAdapter.getInitialState({
  loaded: false,
  loading: false,
  triggerId: null,
  request: null,
  error: null,
});
